module.exports = __webpack_public_path__ + "bin/ead47b16147773029249ec3cf968cb12.svg";